var render, staticRenderFns
import script from "./sale_area.vue?vue&type=script&lang=js&"
export * from "./sale_area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdd5537')) {
      api.createRecord('4fdd5537', component.options)
    } else {
      api.reload('4fdd5537', component.options)
    }
    
  }
}
component.options.__file = "found/views/dms/views/contract/components/sale_area.vue"
export default component.exports